import React from "react";
import SectionCommonTable from "../../components/SectionCommonTable";
import DirectTable from "./table/directTable";

const DirectTeamPage = () => {
  return (
    <SectionCommonTable
      wrapperClassName="directteam_table"
      cardStyle={{ backgroundColor: "#fff" }}
      sectionTableTitle="My Direct Team"
      countContainer="Total Direct IDs : 0"
      table={<DirectTable />}
    />
  );
};

export default DirectTeamPage;
